<!-- 没有遮罩的dialog -->
<style scoped lang="less">
  .base-dialog-x {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
    // background-color: #fff;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 80%;
    padding: 24px 20px 16px 20px;
  }

  .dialog-title {
    color: #333;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
  }

  .base-dialog-content {
    margin: 16px 0 20px;
  }

  .dialog-message {
    color: #333;
    font-size: 15px;
    font-weight: 400;
  }

  .dialog-footer {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    gap: 12px;
  }
</style>

<template>
  <div class="base-dialog-x" :style="dialogStyle">
    <div class="base-dialog-title">
      <slot name="title">
        <div class="dialog-title">{{ title }}</div>
      </slot>
    </div>
    <div class="base-dialog-content">
      <slot name="content">
        <div class="dialog-message">{{ message }}</div>
      </slot>
    </div>
    <div class="base-dialog-footer">
      <slot name="footer">
        <div class="dialog-footer">
          <van-button
            v-if="showCancelBtn"
            plain
            round
            block
            :color="cancelBtnColor"
            @click="cancel"
          >
            {{ cancelBtnText }}
          </van-button>
          <van-button v-if="showConfirmBtn" round block :color="confirmBtnColor" @click="confirm">
            {{ confirmBtnText }}
          </van-button>
        </div>
      </slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
  defineOptions({ name: 'BaseDialog' });
  const imgBaseUrl = inject('imgBaseUrl');
  const props = withDefaults(
    defineProps<
      Partial<{
        zIndex: number;
        title: string;
        message: string;
        showConfirmBtn: boolean;
        confirmBtnText: string;
        confirmBtnColor: string;
        showCancelBtn: boolean;
        cancelBtnText: string;
        cancelBtnColor: string;
      }>
    >(),
    {
      zIndex: 9999,
      title: '提示',
      message: '温馨提示',
      showConfirmBtn: true,
      confirmBtnText: '确定',
      confirmBtnColor: '#186EF9',
      showCancelBtn: true,
      cancelBtnText: '取消',
      cancelBtnColor: '#666',
    }
  );

  const emits = defineEmits<{
    (e: 'confirm'): void;
    (e: 'cancel'): void;
  }>();

  const dialogStyle = computed(() => ({
    'z-index': props.zIndex,
    'background-image': `url(${imgBaseUrl}/v1.0.5/dialog-bg.png)`,
  }));

  const confirm = () => emits('confirm');
  const cancel = () => emits('cancel');
</script>
